import React from "react";
import clsx from "clsx";
import formatISO from "date-fns/formatISO";
import parseISO from "date-fns/parseISO";
import addDays from "date-fns/addDays";

import Divider from "@material-ui/core/Divider";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import FacilityIcon from "components/Icons/Facility";
import { useRacehorse360Api } from "hooks/api";
import { isBlackedOut } from "utils/facilityBlackouts";
import { shouldShutOffDate } from "utils/date-utils";
import useStyles from "./facilityItemStyles";

export interface Props {
  facility: racehorse360.IFacility;
  workoutData: racehorse360.IWorkoutRequest;
  onClick: (id: string) => void;
}

const ScheduleDateMenu = (props: Props) => {
  const { facility, workoutData, onClick } = props;

  const classes = useStyles();

  const { usePullFacilityBlackouts } = useRacehorse360Api();

  const {
    isLoading: isFacilityBlackoutsLoading,
    data: facilityBlackoutsData = { facilityBlackouts: [] }
  } = usePullFacilityBlackouts({
    facilityId: facility.id,
    startDate: formatISO(new Date(), {
      representation: "date"
    }),
    endDate: formatISO(addDays(new Date(), 30), {
      representation: "date"
    })
  });

  const isDisabled = [
    isBlackedOut(
      parseISO(workoutData.date),
      facilityBlackoutsData?.facilityBlackouts
    ),
    shouldShutOffDate(new Date(workoutData.date), facility),
    isFacilityBlackoutsLoading
  ].some(Boolean);

  const handleClick = event => {
    event.stopPropagation();
    onClick(facility.id);
  };

  return (
    <div key={facility.id}>
      <MenuItem
        className={clsx(classes.facility, {
          [classes.disabled]: isDisabled
        })}
        onClick={handleClick}
        disabled={isDisabled}
      >
        <ListItemIcon>
          <FacilityIcon
            selected={workoutData?.facility?.id === facility.id}
            code={workoutData?.facility?.code.trim()}
            backgroundColor={workoutData?.facility?.backgroundColor}
            strokeColor={workoutData?.facility?.strokeColor}
          />
        </ListItemIcon>
        <ListItemText primary={facility.name} />
      </MenuItem>
      <Divider light />
    </div>
  );
};

export default React.memo(ScheduleDateMenu);
